module.exports = __webpack_public_path__ + "img/five-pop-bg2.3e9bbc13.png";